import { render, staticRenderFns } from "./404.vue?vue&type=template&id=71d2e05c&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=71d2e05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d2e05c",
  null
  
)

export default component.exports